app.formEvent = {

    settings: {
        formSelector: '#form-event',
        $form : $('#form-event')
    },

    init: function() {
        app.formEvent.settings.$form.on('submit', app.formEvent.submit);
        app.formEvent.settings.$form.find('[data-price]').on('change', app.formEvent.calculatePrice);
        app.formEvent.settings.$form.find('[name=employee]').on('change', app.formEvent.toggleEmployeeOptions);
        app.formEvent.toggleEmployeeOptions();
    },

    submit: function(ev){

        ev.preventDefault();

        context.submit({
            method: "submitEventform",
            form: app.formEvent.settings.formSelector,
            onSuccess: function(response){

                // app.formEvent.showSuccess();
                // app.formEvent.clearForm();

                window.location.href = response.returnUrl;
            },
            onError: function(){
                app.formEvent.showError();
            }
        });
    },

    showSuccess: function() {
        app.formEvent.settings.$form.find('.btn').removeClass('btn--delta icon--paper-plane btn--epsilon icon--spinner').addClass('btn--dota icon--check').html('Succesvol verzonden');
    },

    showError: function() {
        alert("Er is iets misgegaan. Probeer het later nog eens of neem contact met ons op.");
    },

    clearForm: function(){
        // app.formEvent.settings.$form.find("[name=name]").val("");
    },

    calculatePrice: function() {

        var totalPrice = 0;

        app.formEvent.settings.$form.find('[data-price]').each(function(index, value) {

            if ( $(value).is(':checked') ) {
                totalPrice += parseFloat($(value).data('price'));
            }
        });

        app.formEvent.settings.$form.find('[name=price]').val(totalPrice);

        app.formEvent.settings.$form.find('#event-price-total').html('&euro;' + app.formEvent.formatPrice(totalPrice));
    },

    formatPrice: function(amount) {

        amount = parseFloat(amount);
        var formatted = '0';

        if ( !isNaN(amount) ) {

            formatted = amount.toFixed(2);
            formatted = formatted.replace('.', ',');
            formatted = formatted.replace(',00', ',-');
        }

        return formatted;
    },

    toggleEmployeeOptions: function() {

        var isEmployee = false;

        if ( app.formEvent.settings.$form.find('[name=employee]:checked').val()+'' === '1' ) {
            isEmployee = true;
        }

        if ( isEmployee === true ) {

            // huidige selectie
            var currentIndex = 0;
            app.formEvent.settings.$form.find('[data-default] input').each(function(index, value){

                if ( $(value).is(':checked') ) {
                    currentIndex = index;
                }
            });

            var target = app.formEvent.settings.$form.find('[data-employee]')[currentIndex];
            $(target).find('input').trigger('click');

            app.formEvent.settings.$form.find('[data-default]').hide();
            app.formEvent.settings.$form.find('[data-employee]').show();
        }
        else {

            // huidige selectie
            var currentIndex = 0;
            app.formEvent.settings.$form.find('[data-employee] input').each(function(index, value){

                if ( $(value).is(':checked') ) {
                    currentIndex = index;
                }
            });

            var target = app.formEvent.settings.$form.find('[data-default]')[currentIndex];
            $(target).find('input').trigger('click');

            app.formEvent.settings.$form.find('[data-employee]').hide();
            app.formEvent.settings.$form.find('[data-default]').show();
        }

        // app.formEvent.calculatePrice();
    }
};